<template>
    <div>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <vue-plotly :white-mode="whiteMode" disable-responsive  v-if="!loading&&data" :data="data" :layout="layout" :options="{}"></vue-plotly>
    </div>
</template>

<script>
    import {callAPI} from '@/helper'
    import LoadingProgressBar from './../LoadingProgressBar'
    import VuePlotly from "./../VuePlotly";
    export default {
        props: {
            dateRange: {type: Object, default: null},
            equipmentName:{type: String, default: null},
            whiteMode:{type:Boolean, default: false}
        },
        components: {LoadingProgressBar,VuePlotly},
        computed: {},
        name: 'CorrelationWidget',
        watch: {
            dateRange () {
                this.refresh()
            },
        },
        data: function () {
            return {
                loading: true,
                timeout:null,
                data:null,
                layout:null,
            }
        },
        mounted(){
            this.refresh()
        },
        methods: {
            debounce(callback, wait) {
                clearTimeout(this.timeout);
                this.timeout= setTimeout(() => callback(), wait);
            },
            refresh(){
                this.debounce(this.getData,200);
            },
            getData(){
                let me=this
                me.loading=true
                if(this.equipmentName&&this.equipmentName!==""){
                    callAPI('correlation/',{
                        date_range:[this.dateRange.start,this.dateRange.end],
                        filters: {
                            equipment_name: this.equipmentName,
                            facility_name: me.$store.state.pointsListStore.pointsList.facility_name
                        },
                        pipeline:[]
                    }).then(function(result) {
                        let sensors=Object.keys(result.data)
                        let values=[]
                        for (let key of sensors){
                            values.push(Object.values(result.data[key]))
                        }
                        let colorscaleValue = [
                            [-1, process.env.VUE_APP_THEME=='dark' ? "rgb(31, 119, 180)" : '#0000FF'],
                            [1, process.env.VUE_APP_THEME=='dark' ? "rgb(214, 39, 40)" : '#FF0000']
                        ]
                        sensors=sensors.map(x=>x.split(" - ")[1])
                        me.data = [{
                            x: sensors,
                            y: sensors,
                            z: values,
                            type: 'heatmap',
                            mode: 'markers',
                            colorscale: colorscaleValue,
                            zmin:-1,
                            zmax:1
                        }]
                        me.layout={
                            title: {text: me.equipmentName},
                            height:Math.max(400,25*sensors.length),
                            autosize: true,
                            hovermode: 'closest',
                            margin:{
                                l: 300,
                                r: 50,
                                b: 160,
                                t: 50,
                                pad: 4
                            },
                            yaxis: {
                                title: "",
                                categoryorder:"array",
                                categoryarray:sensors
                            },
                            xaxis: {
                                title: "",
                                categoryorder:"array",
                                categoryarray:sensors
                            },
                        }
                        me.loading=false
                    })
                }
            }
        },

    }

</script>

<style scoped>

</style>
